import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {AccountCommissionSummaryModel} from "./models/accountCommissionSummary.model";
import {BringozArray} from "../persistence-layer/bringoz-array";

angular
  .module('bringoz.admin.accounts')
  .factory('$accountsCommissionsSummary', AccountsCommissionsSummaryFactory);

export type $accountsCommissionsSummaryFactory = () => BringozArray<AccountCommissionSummaryModel>;

/* @ngInject */
function AccountsCommissionsSummaryFactory($bringozFactory: $bringozFactory,
                                           AccountsCommissionsSummaryApi: BringozApi,
                                           AccountsCommissionsSummary_DS: DataStoreConfig) {

  function $accountsCommissionsSummary() {
    return $bringozFactory<AccountCommissionSummaryModel>(null, AccountsCommissionsSummaryApi, AccountsCommissionsSummary_DS);
  }

  return $accountsCommissionsSummary;
}
